// extracted by mini-css-extract-plugin
export default {"members-section__content":"membersSection_members-section__content__nXefW"};